/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_viewer = {
    readonly isFavoritesEnabled?: boolean | null;
    readonly disablePdpExitModal?: boolean | null;
    readonly isAboutTheMakerEnabled?: boolean | null;
    readonly isRingSizesOn?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_viewer" | "PdpRespSidebarBlurbs_viewer" | "PdpRespSidebarButtons_viewer" | "PdpRespShippingReturns_viewer" | "PdpRespSimilarItemsFooter_viewer" | "PdpRespHeroCarousel_viewer" | "PdpRespDealerDetails_viewer" | "PdpRespSidebarContact_viewer" | "PdpRespSidebarSellerInfo_viewer" | "PdpSharedShippingBadge_viewer" | "PdpRespDealerChatLoader_viewer" | "PdpRespAboutModule_viewer" | "PdpSharedRestrictedMaterialsLoader_viewer" | "PdpSharedQuantitySelect_viewer">;
    readonly " $refType": "PdpRespContainer_viewer";
};
export type PdpRespContainer_viewer$data = PdpRespContainer_viewer;
export type PdpRespContainer_viewer$key = {
    readonly " $data"?: PdpRespContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isFavoritesEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "FAVORITES"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabledByLocale",
          "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
        },
        {
          "alias": "disablePdpExitModal",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disablePdpExitModal"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disablePdpExitModal\")"
        },
        {
          "alias": "isAboutTheMakerEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "ABOUT_THE_MAKER"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabledByLocale",
          "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
        },
        {
          "alias": "isRingSizesOn",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "ringSizes"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"ringSizes\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_viewer"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRestrictedMaterialsLoader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '3e952d29165a40f47c416ec8322580a6';
export default node;
